// extracted by mini-css-extract-plugin
export default {"loader":"AddApartmentByProviderId_loader__-a7ji"};